$.fn.svgClippingMask = function(){
    $(this).each(function(){

    var image = $(this).attr('data-image'),
        $template = "<svg preserveAspectRatio='xMidYMid slice' viewBox='0 0 400 400'>\
                      <defs>\
                          <clipPath class='clipPath'>\
                              <circle class='clippingMask' cx='0' cy='0' fill='#000'></circle>\
                          </clipPath>\
                      </defs>\
                      <g class='clipTarget'>\
                          <image height='100%' preserveAspectRatio='xMinYMin slice' width='100%' xlink:href='" + image + "'></image>\
                      </g>\
                    </svg>";

      $(this).html($template);
      var svg = $(this).find('svg'),
         clippingMask = svg.find('.clippingMask'),
         uuid = randomUUID(),
         radius = 200;

      clippingMask.attr('r',radius + 'px');
      svg.find('.clipPath').attr('id',uuid);
      svg.find('.clipTarget').attr('clip-path', 'url(#' + uuid + ')');

      $(this).on('mousemove', function(e){
          var x = e.clientX - $(this).offset().left,
              y = e.clientY - ($(this).offset().top - $(window).scrollTop());

          clippingMask.attr({
            cx:x,
            cy:y
          });
      });

      $(window).resize(function(){
        $(this).html('');
        $(this).append(svg);
      }.bind(this));
    });
}

function makeSVG(tag, attrs) {
    var el= document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs)
        el.setAttribute(k, attrs[k]);
    return el;
}